<div class="liberro-help-box">
  <div>
    <div class="heading">{{ headingTranslationKey | translate }}</div>
    <div class="description">{{ contentTranslationKey | translate }}</div>
  </div>
  <div>
    <div class="contact-label">{{ 'help-box.labelWriteToUs' | translate }}</div>
    <div class="contact-value">
      <a [attr.href]="'mailto:' + (emailTranslationKey | translate)">
        {{ emailTranslationKey | translate }}
      </a>
    </div>
    <div class="contact-label">{{ 'help-box.labelCallUs' | translate }}</div>
    <div class="contact-value">
      <a [attr.href]="'tel:' + ('help-box.phone' | translate)">
        {{ 'help-box.phone' | translate }}
      </a>
    </div>
    @if (hotlineAvailability) {
      <div class="info-hours">
        <liberro-hotline-availability
          [hotlineAvailability]="hotlineAvailability!"
        ></liberro-hotline-availability>
      </div>
    }
  </div>
</div>
